import type { ExtractedField } from "../../types"
import { PAYMENT_TERMS_OPTIONS } from "../../fieldConstants"
import { EditableSelectField } from "./EditableSelectField"

interface PaymentTermsFieldProps {
  field: ExtractedField
  editableFieldAttr: Record<string, string>
  focusTargetAttr: Record<string, string>
  onSelectChange: (field: ExtractedField, value: string) => void
  disabled?: boolean
}

export const PaymentTermsField = ({
  field,
  editableFieldAttr,
  focusTargetAttr,
  onSelectChange,
  disabled
}: PaymentTermsFieldProps): JSX.Element => {
  const isKnownValue = PAYMENT_TERMS_OPTIONS.some((option) => option.value === field.field_value)
  const selectValue = isKnownValue ? field.field_value ?? undefined : undefined

  return (
    <EditableSelectField
      value={selectValue}
      placeholder="Изберете начин на плащане"
      options={PAYMENT_TERMS_OPTIONS}
      onChange={(value) => onSelectChange(field, value)}
      editableFieldAttr={editableFieldAttr}
      focusTargetAttr={focusTargetAttr}
      disabled={disabled}
    />
  )
}
